import React, { Component } from 'react';
import Header from './Header';
import Results from './Results';
import IFrame from './IFrame';
import Transcript from './Transcript';

class SearchPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      videoId: null,
    }
  }

  componentDidMount() {
    this._setupData();
  }

  _setupData = () => {
    const { endpoint, query } = this.props;
    this.setState({
      loading: query,
    });
    fetch(endpoint + '?q=' + query).then(res => {
      return res.json();
    }).then(res => {
      if (this.state.loading === query) {
        this.setState({
          loading: false,
          loaded: query,
          data: res,
        });
      }
    });
  }

  _onTargetReady = (target) => {
    this._player = target;
  }

  _onVideoClick = (ytid, ts) => {
    const {videoId} = this.state;
    if (videoId === ytid) {
      this._player.seekTo(ts, true);
    } else {
      this._player.cueVideoById(ytid, ts, 'medium');
      this.setState({
        videoId: ytid,
      });
    }
    this._player.playVideo();
  }

  _getVideo = () => {
    const {data, videoId} = this.state;
    return data && data.find(x => x._source && x._source.video_id === videoId)
  }

  _onSubmit = (e) => {
    e.preventDefault();
    this._setupData();
  }

  render() {
    const {query} = this.props;
    const {loaded, loading, data, videoId} = this.state;
    const video = this._getVideo();
    const keywords = query.toLowerCase().split(' ');
    return (
      <div className="SearchPage">
        <Header query={this.props.query} onSubmit={this._onSubmit} />
        <div className="container">
          {loading && <p>Loading results for {loading}...</p>}
          {!loading && data && <p>Showing {data.length} results for "{loaded}".</p>}
        </div>
        <div className="container">
          <Results onVideoClick={this._onVideoClick} videos={data} keywords={keywords} />
          <div className="videoArea">
            <IFrame onTargetReady={this._onTargetReady} videoId="2g811Eo7K8U" />
            <p>Results</p>
            {video &&
             <Transcript cues={video._source.cues}
               relevantCues = {video._source.relevantCues}
               onVideoClick={this._onVideoClick}
               videoId={video._source.video_id}
               keywords={keywords}
               full={true} />}
          </div>
        </div>
      </div>
    );
  };
}

export default SearchPage;



// WEBPACK FOOTER //
// ./src/SearchPage/SearchPage.js